import React from "react";
import { Card } from "react-bootstrap";
import "./InfoPopup.scss";

export const InfoPopup = ({ hoveredArea }) => {
  return (
    <Card id={"info-popup"} className={"info-popup"}>
      <Card.Img id="infoPopupImg" variant="top" src={`./axonos/images/${hoveredArea.name.axono}.webp`} />
      <Card.Body>
        <Card.Title>{hoveredArea.name.title}</Card.Title>
          <Card.Text>
              {hoveredArea.name.surface && <span className={"p-0 m-0 mr-2"}>{hoveredArea.name.surface} sq ft</span>}
              {hoveredArea.name.surface_sub && <span className={"p-0 m-0"}>{hoveredArea.name.surface_sub}</span>}
          </Card.Text>
          <Card.Text>
              {hoveredArea.name.description}
          </Card.Text>
      </Card.Body>
    </Card>
  );
};
